import React, { useEffect, useState } from "react";
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import { useNavigate } from "react-router";
import { SEVERITY } from '../../utils/Snackbar';

import { getUserData } from '../../utils/LocalStorage';
import { get, put, del } from '../../utils/Api';
import UsuariosToolbar from '../../toolbars/UsuariosToolbar';
import ConfirmDialog from '../../dialogs/ConfirmDialog';

import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';

import EditIcon from '@mui/icons-material/Edit';
import ClearIcon from '@mui/icons-material/Clear';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import DeleteIcon from '@mui/icons-material/Delete';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';

import StaticBox from '../../utils/StaticBox';

import logo_menu from '../../assets/logo-menu.png';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#1565c0',
    color: theme.palette.common.white,
  },
}));

export const DRAWER_WIDTH = 240;

const headCells = [
  {
    id: 'usuario_nome',
    label: 'Nome do Usuário',
  },
  {
    id: 'usuario_email',
    label: 'E-mail do Usuário',
  },
  {
    id: 'registro_refresh',
    label: 'Último acesso',
  },
  {
    id: 'usuario_ativo_nome',
    label: 'Situação',
  },
  {
    id: 'perfil_nome',
    label: 'Perfil',
  },
  {
    id: 'quantidade_documentos_cadastrados',
    label: 'Iniciais',
  },
];

const defaultEmptyMessage = 'Não há documentos cadastrados!';

function EnhancedTableHead(usuarioRoot) {
  return (
    <>
      <TableHead
        sx={{
          display: { xs: 'none', sm: 'table-header-group' },
        }}>
        <TableRow>
          <StyledTableCell padding="checkbox" />
          {headCells.map((headCell) => (
            <StyledTableCell
              key={(usuarioRoot && headCell.id === 'quantidade_documentos_cadastrados') ? 'escritorio_nome_column' : headCell.id}
            >
              <Typography>
                {(usuarioRoot && headCell.id === 'quantidade_documentos_cadastrados') ? 'Escritório' : headCell.label}
              </Typography>
            </StyledTableCell>
          ))}
        </TableRow>
      </TableHead>

      <TableHead
        sx={{
          display: { xs: 'table-header-group', sm: 'none' },
        }}>
        <TableRow>
          <StyledTableCell
            key={headCells[0].id}
          >
            <Typography>
              {headCells[0].label}
            </Typography>
          </StyledTableCell>
        </TableRow>
      </TableHead>
    </>
  );
}

export default function Usuarios({
  setLoading,
  handleMessage,
  mainError,
  setError,
  version,
  mobileOpen,
  setMobileOpen,
  ...props
}) {
  const navigate=useNavigate();

  const [refresh,setRefresh] = useState(crypto.randomUUID());

  const { window } = props;
  const container = window !== undefined ? () => window().document.body : undefined;

  const [selected, setSelected] = useState('');
  const [situacaoNome, setSituacaoNome] = useState('');
  const [nomeSocial, setNomeSocial] = useState('');
  const [usuarios, setUsuarios] = useState([]);
  const [usuariosFiltrados, setUsuariosFiltrados] = useState([]);
  const [usuarioRoot,setUsuarioRoot] = useState(false);
  const [usuarioUUID,setUsuarioUUID] = useState('');

  const handleCloseDrawer = () => {
    setSelected('');
    setSituacaoNome('');
    setNomeSocial('');
    setMobileOpen(false);
  };

  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);

  const handleOpenDeleteDialog = () => {
    if (usuarioUUID === selected) {
      handleMessage('Você não pode se excluir!',SEVERITY.WARNING.toString(),'',false);
    } else {
      setOpenDeleteDialog(true);
    }
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
  };

  const handleAgreeDeleteDialog = () => {
    setOpenDeleteDialog(false);

    if (mainError) { return; }
    setLoading(true);

    del(`api/usuario/${selected}`,{},(json,message,severity)=>{
      setSelected('');
      setSituacaoNome('');
      setNomeSocial('');
      setMobileOpen(false);
      setLoading(false);

      if (json.excluido) {
        setRefresh(crypto.randomUUID());
        handleMessage('Usuário excluído com sucesso!',severity,'',false);
      } else {
        handleMessage('Erro ao excluir o usuário!',SEVERITY.ERROR.toString(),'',true);
      }

    },(error,message,severity)=>{
      setLoading(false);
      handleMessage(message,severity,error,true);
    });
  };

  const [openDisableDialog, setOpenDisableDialog] = React.useState(false);

  const handleOpenDisableDialog = () => {
    if (cadastroPendente(nomeSocial)) {
      handleMessage('Este usuário está com o cadastro pendente!',SEVERITY.WARNING.toString(),'',false);
    } else if (usuarioUUID === selected) {
      handleMessage('Você não pode se desativar!',SEVERITY.WARNING.toString(),'',false);
    } else {
      setOpenDisableDialog(true);
    }
  };

  const handleCloseDisableDialog = () => {
    setOpenDisableDialog(false);
  };

  const handleAgreeDisableDialog = () => {
    setOpenDisableDialog(false);

    if (mainError) { return; }
    setLoading(true);

    put(`api/usuario/${selected}/situacao/desativar`,{},(json,message,severity)=>{
      setSelected('');
      setSituacaoNome('');
      setNomeSocial('');
      setMobileOpen(false);
      setLoading(false);
      setRefresh(crypto.randomUUID());
      handleMessage('Usuário desativado com sucesso!',severity,'',false);
    },(error,message,severity)=>{
      setLoading(false);
      handleMessage(message,severity,error,true);
    });
  };

  const handleEditarUsuario = () => {
    if (cadastroPendente(nomeSocial)) {
      handleMessage('Este usuário está com o cadastro pendente!',SEVERITY.WARNING.toString(),'',false);
    } else {
      navigate(`/usuario/${selected}`);
    }
  };

  const handleAtivarUsuario = (callback) => {
    if (cadastroPendente(nomeSocial)) {
      handleMessage('Este usuário está com o cadastro pendente!',SEVERITY.WARNING.toString(),'',false);
      callback();
    } else {
      put(`api/usuario/${selected}/situacao/ativar`,{},(json,message,severity)=>{
        setSelected('');
        setSituacaoNome('');
        setNomeSocial('');
        setMobileOpen(false);
        callback();
        setLoading(false);
        setRefresh(crypto.randomUUID());
        handleMessage('Usuário ativado com sucesso!',severity,'',false);
      },(error,message,severity)=>{
        callback();
        setLoading(false);
        handleMessage(message,severity,error,true);
      });
    }
  };

  const handleReenviarEmail = () => {
    if (!cadastroPendente(nomeSocial)) {
      handleMessage('Este usuário já completou o cadastro!',SEVERITY.WARNING.toString(),'',false);
    } else {
      navigate(`/reenviar-email/${selected}`);
    }
  };

  const handleSearch = (event) => {
    setSelected('');
    setSituacaoNome('');
    setNomeSocial('');
    let filtro = event.target.value;
    setUsuariosFiltrados(usuarios.filter(
      usuario => usuario.usuario_nome.toLowerCase().includes(filtro.toLowerCase()) ||
      usuario.usuario_ativo_nome.toLowerCase().includes(filtro.toLowerCase()) ||
      usuario.perfil_nome.toLowerCase().includes(filtro.toLowerCase()) ||
      usuario.usuario_email.toLowerCase().includes(filtro.toLowerCase())
    ));
  };

  useEffect(()=>{
    const closeDrawer = () => {
      setLoading(false);
      setSelected('');
      setSituacaoNome('');
      setNomeSocial('');
      setMobileOpen(false);
    };

    const getUsuarios = () => {
      if (mainError) {
        closeDrawer();
        return;
      }

      getUserData((administrador,root,escritorio_uuid,usuario_uuid)=>{
        setUsuarioRoot(root);
        setUsuarioUUID(usuario_uuid);

        get('api/usuarios',(json)=>{
          setUsuarios(json);
          setUsuariosFiltrados(json);
          closeDrawer();
        },(error,message,severity)=>{
          handleMessage(message,severity,error,true);
          closeDrawer();
        });

      });
    };

    getUsuarios();
  },[refresh]);

  const handleClick = (event, id, situacao, nome_social) => {
    if (id === selected) {
      setSelected('');
      setSituacaoNome('');
      setNomeSocial('');
      setMobileOpen(false);
    } else {
      setSelected(id);
      setSituacaoNome(situacao);
      setNomeSocial(nome_social);
      setMobileOpen(true);
    }
  };

  const cadastroPendente = (usuario_nome_social) => {
    return (usuario_nome_social === '(cadastro pendente)');
  };

  return (
    <React.Fragment>
      <ConfirmDialog
        openConfirmDialog={openDeleteDialog}
        handleCloseDialog={handleCloseDeleteDialog}
        handleAgreeDialog={handleAgreeDeleteDialog}
        title={"Aviso"}
        message={"Deseja excluir permanentemente este usuário?"}
        disagree={"Voltar"}
        agree={"Excluir"}
      />

      <ConfirmDialog
        openConfirmDialog={openDisableDialog}
        handleCloseDialog={handleCloseDisableDialog}
        handleAgreeDialog={handleAgreeDisableDialog}
        title={"Aviso"}
        message={"Deseja desativar este usuário?"}
        disagree={"Voltar"}
        agree={"Desativar"}
      />

      <StaticBox
        version={version}
        setLoading={setLoading}
        handleMessage={handleMessage}
        error={mainError}
        setError={setError}>
        <React.Fragment>
          <UsuariosToolbar
            selected={selected}
            situacaoNome={situacaoNome}
            nomeSocial={nomeSocial}
            cadastroPendente={cadastroPendente}
            handleSearch={handleSearch}
            handleOpenDisableDialog={handleOpenDisableDialog}
            handleOpenDeleteDialog={handleOpenDeleteDialog}
            handleAtivarUsuario={handleAtivarUsuario}
            handleReenviarEmail={handleReenviarEmail}
            handleEditarUsuario={handleEditarUsuario}
            handleMessage={handleMessage}
          />
          <TableContainer component={Paper} sx={{ height: '96%' }}>
            <Table
              sx={{ minWidth: { xs: 0, sm: 750 } }}
              aria-labelledby="tableTitle"
              size={'medium'}
            >
              <EnhancedTableHead />
              <TableBody>
                {
                  (usuariosFiltrados.length === 0) ? (
                    <TableRow>
                      <TableCell
                        colSpan={7}
                        align="center"
                        sx={{
                          display: { xs: 'none', sm: 'table-cell' },
                        }}>
                        {defaultEmptyMessage}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          display: { xs: 'table-cell', sm: 'none' },
                        }}>
                        {defaultEmptyMessage}
                      </TableCell>
                    </TableRow>
                  ) : (
                    usuariosFiltrados.map((row, index) => {
                      const isItemSelected = (selected === row.usuario_uuid);
                      const labelId = `enhanced-table-checkbox-${index}`;
                      const pendente = cadastroPendente(row.usuario_nome_social);

                      return (
                        <TableRow
                          hover
                          onClick={(event) => handleClick(
                            event,
                            row.usuario_uuid,
                            row.usuario_ativo_nome,
                            row.usuario_nome_social,
                          )}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.usuario_uuid}
                          selected={isItemSelected}
                          sx={{ cursor: 'pointer' }}
                        >
                          <TableCell padding="checkbox"
                            sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                            <Checkbox
                              color="primary"
                              checked={isItemSelected}
                            />
                          </TableCell>
                          <TableCell
                            component="th"
                            id={labelId}
                            scope="row"
                          >
                            <Typography component="span" sx={{
                              display: { xs: 'none', sm: 'inline-block' },
                              lineHeight: { xs: '40px', sm: '0' },
                            }}>
                              {row.usuario_nome}
                            </Typography>
                            <Typography component="span" sx={{
                              display: { xs: 'inline-block', sm: 'none' },
                              lineHeight: { xs: '40px', sm: '0' },
                            }}>
                              {pendente ? row.usuario_email : row.usuario_nome_social }
                            </Typography>
                            {
                              (usuarioRoot) ? (
                                <Chip
                                  label={row.escritorio_nome}
                                  color={'azul'}
                                  sx={{ ml: '10px', mb: '5px', display: { xs: 'inline-flex', sm: 'none' } }}
                                />
                              ) : (<></>)
                            }
                            <Chip
                              label={pendente ? 'Cadastro pendente' : row.usuario_ativo_nome}
                              color={row.usuario_ativo_nome.toLowerCase()}
                              sx={{ ml: '10px', mb: '5px', display: { xs: 'inline-flex', sm: 'none' } }}
                            />
                          </TableCell>
                          <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{row.usuario_email}</TableCell>
                          <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{<Chip label={row.registro_refresh} color={'elaboracao'} />}</TableCell>                          
                          <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}><Chip label={row.usuario_ativo_nome} color={row.usuario_ativo_nome.toLowerCase()} /></TableCell>
                          <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{<Chip label={row.perfil_nome} color={'elaboracao'} />}</TableCell>
                          <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{
                            usuarioRoot ? row.escritorio_nome : row.quantidade_documentos_cadastrados
                          }</TableCell>
                        </TableRow>
                      );
                    })
                  )
                }

              </TableBody>
            </Table>
          </TableContainer>
        </React.Fragment>
      </StaticBox>

      <Fab
        color="success"
        aria-label="add"
        sx={{
          position: 'absolute',
          bottom: 35,
          right: 35,
          display: { xs: 'flex', sm: 'none' },
        }}
        onClick={()=>{
          navigate('/cadastrar-usuario');
        }}>
        <AddIcon />
      </Fab>

      <Fab
        variant="outlined"
        aria-label="fab-export"
        onClick={()=>{
          navigate(`/`);
        }}
        sx={{
          position: 'absolute',
          bottom: 35,
          left: 35,
          display: { xs: 'flex', sm: 'none' },
        }}>
        <ArrowBackIcon />
      </Fab>

      <Box
        component="nav"
        sx={{ width: { sm: DRAWER_WIDTH }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={()=>{handleCloseDrawer()}}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: DRAWER_WIDTH },
          }}>
          <div>
            <Box
              sx={{
                display: 'block',
                my: 2,
                textAlign: 'center',
              }}>
              <Box
                component="img"
                sx={{ maxWidth: 60, paddingTop: 1 }}
                alt="Logo"
                src={logo_menu}
              />
            </Box>
            <Divider sx={{ display: 'block' }}/>
            <List>

              <ListItem
                key="Editar"
                disablePadding>
                <ListItemButton
                  sx={{ pt: 0.6, pb: 0.6, m: 0 }}
                  onClick={handleEditarUsuario}
                >
                  <ListItemIcon sx={{ minWidth: '40px', }}>
                    <EditIcon />
                  </ListItemIcon>
                  <ListItemText primary="Editar" />
                </ListItemButton>
              </ListItem>

              {
                situacaoNome === 'Ativo' ? (
                  <ListItem
                    key="Desativar"
                    disablePadding>
                    <ListItemButton
                      sx={{ pt: 0.6, pb: 0.6, m: 0 }}
                      onClick={()=>{handleOpenDisableDialog()}}
                    >
                      <ListItemIcon sx={{ minWidth: '40px', }}>
                        <PersonOffIcon />
                      </ListItemIcon>
                      <ListItemText primary="Desativar" />
                    </ListItemButton>
                  </ListItem>
                ) : (
                  <ListItem
                    key="Ativar"
                    disablePadding>
                    <ListItemButton
                      sx={{ pt: 0.6, pb: 0.6, m: 0 }}
                      onClick={()=>{
                        handleAtivarUsuario(()=>{
                          handleCloseDrawer();
                        });
                      }}
                    >
                      <ListItemIcon sx={{ minWidth: '40px', }}>
                        <PersonIcon />
                      </ListItemIcon>
                      <ListItemText primary="Ativar" />
                    </ListItemButton>
                  </ListItem>
                )
              }

              <ListItem
                key="Excluir"
                disablePadding>
                <ListItemButton
                  sx={{ pt: 0.6, pb: 0.6, m: 0 }}
                  onClick={()=>{handleOpenDeleteDialog()}}
                >
                  <ListItemIcon sx={{ minWidth: '40px', }}>
                    <DeleteIcon />
                  </ListItemIcon>
                  <ListItemText primary="Excluir" />
                </ListItemButton>
              </ListItem>

              <ListItem
                key="Reenviar_Email"
                disablePadding>
                <ListItemButton
                  sx={{ pt: 0.6, pb: 0.6, m: 0 }}
                  onClick={handleReenviarEmail}
                >
                  <ListItemIcon sx={{ minWidth: '40px', }}>
                    <EmailIcon />
                  </ListItemIcon>
                  <ListItemText primary="Reenviar" />
                </ListItemButton>
              </ListItem>

              <ListItem
                key="Fechar-Menu"
                disablePadding>
                <ListItemButton
                  sx={{ pt: 0.6, pb: 0.6, m: 0 }}
                  onClick={()=>{handleCloseDrawer()}}
                >
                  <ListItemIcon sx={{ minWidth: '40px', }}>
                    <ClearIcon />
                  </ListItemIcon>
                  <ListItemText primary="Fechar Menu" />
                </ListItemButton>
              </ListItem>

            </List>
          </div>
        </Drawer>
      </Box>
    </React.Fragment>
  );
}
